module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466806276_ch01#ch01"
    }
  }, [_vm._v("A Man from Her Past")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466806276_ch02#ch02"
    }
  }, [_vm._v("Dog and Me")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466806276_ch03#ch03"
    }
  }, [_vm._v("Enlightened")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466806276_ch04#ch04"
    }
  }, [_vm._v("The Good Taste Contest")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466806276_ch05#ch05"
    }
  }, [_vm._v("Collaboration with Fly")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466806276_ch06#ch06"
    }
  }, [_vm._v("Kafka Cooks Dinner")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tropical Storm")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Times")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Idea for a Short Documentary Film")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forbidden Subjects")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Types")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Senses")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grammar Questions")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hand")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Caterpillar")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Childcare")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Miss You: A Study of Get-Well Letters from a Class of Fourth-Graders")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Passing Wind")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Television")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jane and the Cane")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting to Know Your Body")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Absentminded")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southward Bound, Reads "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Worstward Ho")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Walk")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Varieties of Disturbance")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lonely")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs. D and Her Maids")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Sculptures in One Hour")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietszche")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What You Learn About the Baby")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Her Mother’s Mother")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How It Is Done")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Insomnia")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burning Family Members")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Way to Perfection")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fellowship")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helen and Vi: A Study in Health and Vitality")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reducing Expenses")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother’s Reaction to My Travel Plans")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Sixty Cents")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Shall I Mourn Them?")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Strange Impulse")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How She Could Not Drive")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suddenly Afraid")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Better")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Head, Heart")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Strangers")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Busy Road")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Order")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fly")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traveling with Mother")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index Entry")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch53#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Son")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example of the Continuing Past Tense in a Hotel Room")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cape Cod Diary")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch56#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almost Over: What’s the Word?")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_ch57#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Different Man")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_fm02#fm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466806276_fm03#fm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8777ad66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781466806276_con01.vue
// module id = 72
// module chunks = 0